import { render, staticRenderFns } from "./CausaliDocumentoList.vue?vue&type=template&id=2400af7a"
import script from "./CausaliDocumentoList.vue?vue&type=script&lang=js"
export * from "./CausaliDocumentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports